(function () {
  'use strict';
  /* Rangees horizontales du catalogue (produits / packs) : fleches
     precedent/suivant, masquees en debut/fin ou quand tout tient.
     Le defilement lui-meme est natif (overflow-x + scroll-snap).
     + « Lire la suite » des cartes pack : bascule aria-expanded / classe
     is-open sur le texte, sans ouvrir la fiche (listener delegue unique). */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(row) {
    if (row.__tpRow) return;
    row.__tpRow = true;
    var track = row.querySelector('[data-tp-row-track]');
    var prev = row.querySelector('[data-tp-row-prev]');
    var next = row.querySelector('[data-tp-row-next]');
    if (!track || !prev || !next) return;
    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var overflow = max > 4;
      prev.hidden = !overflow || track.scrollLeft <= 4;
      next.hidden = !overflow || track.scrollLeft >= max - 4;
      row.classList.toggle('has-overflow', overflow);
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    track.addEventListener('focusin', function (e) { var card = e.target.closest('[data-tp-row-track] > *'); if (card && card.scrollIntoView) card.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); });
    update();
    window.setTimeout(update, 250);
  }
  function init() { document.querySelectorAll('[data-tp-row]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('tp:grid:updated', init);
  window.addEventListener('load', init);

  if (!window.__tpReadMoreBound) {
    window.__tpReadMoreBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tp-read-more]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var text = document.getElementById(btn.getAttribute('aria-controls'));
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? (btn.dataset.labelLess || 'Réduire') : (btn.dataset.labelMore || 'Lire la suite');
      if (text) text.classList.toggle('is-open', open);
    });
  }
})();